import OM from '@/api/order-management'

export const PaymentProcessMixin = {
  data() {
    return {
      detectCloseInterval: null,
      failureTimer: null,
      infoTimer: null,
      timer: null
    }
  },
  methods: {
    emitUpdateReceiptAddress(address) {
      this.receiptInfo.county = address.county
      this.receiptInfo.district = address.district
      this.receiptInfo.address = address.address
      this.receiptInfo.postalCode = address.postalCode
      this.invoiceFormRequired()
    },
    setNewInvoiceInfo() {
      this.selectedEnvoiceAddress = '2'
      this.receiptInfo = {
        name: '',
        mobile: '',
        postalCode: '',
        county: '',
        district: '',
        address: ''
      }
    },
    invoiceFormRequired() {
      this.invalidInvoiceError = {}
      const invoiceType = this.selectedEnvoiceWay?.type || this.selectedEnvoice

      if (invoiceType === 'donate' && this.donation === '') {
        this.invalidInvoiceError['donation'] = 'field_required'
      } else if (
        invoiceType === 'duplicate' &&
        this.selectedEnvoiceAddress === '2'
      ) {
        for (const i in this.receiptInfo) {
          const item = this.receiptInfo[i]
          if (!item || item === '' || !/^(?!\s*$).+/.test(item)) {
            this.invalidInvoiceError[i] = 'field_required'
          } else if (i === 'email' && !/.+@.+\..+/.test(item)) {
            this.invalidInvoiceError[i] = 'email_format_error'
          }
        }
      } else if (invoiceType === 'triplicate') {
        const keys = ['company', 'companyCode']
        for (const key of keys) {
          if (!this[key] || this[key] === '' || !/^(?!\s*$).+/.test(this[key])) {
            this.invalidInvoiceError[key] = 'field_required'
          }
        }
      }
      this.hasInvoiceInvalid = Object.keys(this.invalidInvoiceError).length > 0
      return Object.keys(this.invalidInvoiceError).length === 0
    },
    receiptInfoContent(type) {
      if (type === 'donate') {
        return { organization: this.donation ? this.donation.split(' ')[0] : '' }
      }
      if (type === 'duplicate') return this.receiptInfo
      if (type === 'triplicate') {
        return {
          organization: this.company,
          taxIdNumber: this.companyCode
        }
      }
      return null
    },
    async getUserCCInfo() {
      this.loadingCCList = true
      this.loadCCFailed = false
      try {
        const { data: getCCresponse } = await OM.getUserCCInfo()
        if (getCCresponse && getCCresponse.errCode === '00') {
          this.ccList = getCCresponse.ccList || []
        } else {
          this.loadCCFailed = true
        }
      } catch (e) {
        this.loadCCFailed = true
      } finally {
        this.loadingCCList = false
        if (this.$store) {
          this.$store.dispatch('setOverlayLoading', false)
        }
      }
    },
    async updateCCInfo() {
      if (window.win && !window.win.closed) {
        window.open(window.winUrl, 'credit-page')
      } else {
        window.win = window.open('', 'credit-page')
        try {
          const { data: updateCCResponse } = await OM.updateCCInfo()
          if (updateCCResponse && updateCCResponse.errCode === '00' && updateCCResponse.url) {
            window.win.location = updateCCResponse.url
            window.winUrl = updateCCResponse.url
            if (this.detectCloseInterval) clearInterval(this.detectCloseInterval)
            this.detectCloseInterval = setInterval(() => {
              if (!window.win || window.win.closed) {
                if (this.$store) this.$store.dispatch('setOverlayLoading', true)
                window.win = null
                window.winUrl = null
                clearInterval(this.detectCloseInterval)
                this.detectCloseInterval = null
                setTimeout(() => {
                  this.getUserCCInfo()
                }, 3000)
              }
            }, 500)
          }
        } catch (e) {
          if (window.win) {
            window.win.close()
            window.win = null
          }
        }
      }
    },
    cleanupPaymentTimers() {
      if (this.detectCloseInterval) {
        clearInterval(this.detectCloseInterval)
        this.detectCloseInterval = null
      }
      if (this.infoTimer) {
        clearTimeout(this.infoTimer)
        this.infoTimer = null
      }
      if (this.failureTimer) {
        clearTimeout(this.failureTimer)
        this.failureTimer = null
      }
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    }
  },
  beforeDestroy() {
    this.cleanupPaymentTimers()
  }
}
